import { Toast } from '@common/overlay-manager';

export const alertAppVersionUpdate = async () => {
  return Toast.show(
    '현재 앱 버전에서는\n찜, 즐겨찾기 기능을 제공하지 않습니다.\n최신 버전으로 업데이트 후 이용 가능합니다.',
  );
};
